import * as vendorListJson from '../resource/vendorlist.json';
import { VendorList } from 'consent-string';

export default function getVendorListJson(): VendorList {
    return <any>vendorListJson.default;
}
